var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewTab = function SvgNewTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.444 17.444H6.556V6.556H12V5H6.556C5.692 5 5 5.7 5 6.556v10.888C5 18.3 5.692 19 6.556 19h10.888C18.3 19 19 18.3 19 17.444V12h-1.556zM13.556 5v1.556h2.792L8.702 14.2 9.8 15.298l7.645-7.646v2.792H19V5z"
  })));
};
export { SvgNewTab as ReactComponent };